import React, { useEffect, useState, useRef } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "./sidebardata";
import Chatbot from '../Bot/Chatbot';
import { ChevronLeft, User, Grid, Layers, Bookmark, RefreshCw, Calendar, Clock, Activity, Sun, DollarSign, Camera, MapPin, Layout, Box, Briefcase, Bell, FileText, Users, Award, TrendingUp, FileMinus, FilePlus, List, Settings, Clipboard, BarChart2, Home } from 'react-feather';
import { FaUsers, FaBriefcase, FaCalendarAlt, FaPlaneArrival, FaPlaneDeparture, FaBed, FaDoorOpen } from 'react-icons/fa';

const Sidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = useTranslation();
  const [sidebarData, setSidebarData] = useState(SidebarData);
  const [isSideMenu, setIsSideMenu] = useState("feedback-settings");
  const profileTabRef = useRef(null);
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  const toggleChatbot = (e) => {
    setIsChatbotOpen((prev) => !prev);
  };

  useEffect(() => {
    if (profileTabRef.current) {
      profileTabRef.current.click();
    }
  }, []);

  useEffect(() => {
    const menuMapping = {
      '/hospitality': 'employee',
      '/departments': 'employee',
      '/designations': 'employee',
      '/profile': 'profile',
      '/leave-types': 'employee',
      '/holidays': 'employee',
      '/shift-list': 'employee',
      '/overtime': 'employee',
      '/announcements': 'employee',
      '/leaves-employee': 'leaves',
      '/adminleaves': 'leaves',
      '/leave-applications': 'leaves',
      '/leaves-balance': 'leaves',
      '/leave-settings': 'leaves',
      '/attendance-weekly': 'attendance',
      '/attendance-daily': 'attendance',
      '/adminattendance': 'attendance',
      '/attendance-employee': 'attendance',
      '/payroll-overview': 'payroll-overview',
      '/salary': 'payroll-overview',
      '/payroll-items': 'payroll-overview',
      '/run-payroll': 'payroll-overview',
      '/payroll-settings': 'payroll-overview',
      '/payroll-history': 'payroll-overview',
      '/payroll-reports': 'payroll-overview',
      '/devices': 'devices',
      '/deviceslog': 'devices',
      '/device-users': 'devices',
      '/manage-locations': 'company-settings',
      '/feedback/feedback-setting': 'feedback',
      '/feedback/feedback-responses': 'feedback',
      '/property-configuration': 'property-configuration',
    };

    const matchedMenu = Object.keys(menuMapping)
      .sort((a, b) => b.length - a.length)
      .find(route => pathname.startsWith(route)) || "";
    
    if (matchedMenu) {
      toggleSidebar(menuMapping[matchedMenu]);
    } else {
      toggleSidebar('feedback');
    }
  }, [pathname]);

  useEffect(() => {
    if (!isSideMenu) {
      toggleSidebar('employee-dashboard');
    }
  }, []);

  const expandSubMenus = (menu) => {
    const updatedAdminSidebar = sidebarData.map((section) => {
      const updatedSection = { ...section };
      updatedSection.menu = section.menu.map((menuItem) =>
        menu.menuValue !== menuItem.menuValue
          ? { ...menuItem, showSubRoute: false }
          : { ...menuItem, showSubRoute: true }
      );
      return updatedSection;
    });
    setSidebarData(updatedAdminSidebar);
  };

  const toggleSidebar = (value) => {
    setIsSideMenu(value);
  };

  const normalizedPath = pathname.replace(/\/+$/, "") || "/";

  const normalizeRoute = (route) =>
    String(route || "").replace(/\/+$/, "") || "/";

  // Exact is used for the Channel Manager Dashboard so it does not remain
  // highlighted on every child route.
  const isActive = (routes) => {
    const routeArray = Array.isArray(routes) ? routes : [routes];
    return routeArray.some((route) => normalizedPath === normalizeRoute(route));
  };

  // Section-aware state keeps nested pages anchored to the right module.
  // Example: /channel-manager/ari/<property> -> Rates & Availability.
  const isSectionActive = (routes) => {
    const routeArray = Array.isArray(routes) ? routes : [routes];
    return routeArray.some((route) => {
      const base = normalizeRoute(route);
      return normalizedPath === base || normalizedPath.startsWith(`${base}/`);
    });
  };

  return (
    <>
      <div className="sidebar">
 
        <div className="sidebar-inner" >
          <div className="sidebar sidebar-twocol">
   
            <div className="sidebar-right"  style={{ 
        position: 'absolute', // or 'fixed' depending on desired behavior
        left: '0px', 
        width: "100%",
      }}
    >
              <div className="tab-content-horizontal" id="v-pills-tabContent">
                {isSideMenu === "dashboard" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li>
                          <Link
                            className={isActive(['/employee-dashboard']) ? "active" : ""}
                            to="/employee-dashboard"
                          >
                            <Home size={16} style={{ marginRight: '4px' }} /> {t("My Dashboard")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
  
   
{isSideMenu === "feedback" && (
<div className="tab-pane fade active show">
  <nav
    className="submenu-horizontal cm-channel-topnav cm-channel-topnav--channel"
    aria-label="Channel Manager navigation"
  >
    <ul className="cm-channel-topnav-list">
      <li className="cm-channel-nav-item cm-channel-nav-primary">
        <Link
          className={isActive(["/channel-manager"]) ? "active" : ""}
          aria-current={isActive(["/channel-manager"]) ? "page" : undefined}
          to="/channel-manager"
          title="Channel Manager Dashboard"
        >
          <Home size={16} aria-hidden="true" />
          <span>{t("Dashboard")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-item cm-channel-nav-primary">
        <Link
          className={isSectionActive(["/channel-manager/list-channels"]) ? "active" : ""}
          aria-current={isSectionActive(["/channel-manager/list-channels"]) ? "page" : undefined}
          to="/channel-manager/list-channels"
          title="Connected Channels"
        >
          <Layers size={16} aria-hidden="true" />
          <span>{t("Connected Channels")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-item cm-channel-nav-primary cm-channel-nav-key">
        <Link
          className={isSectionActive(["/channel-manager/ari"]) ? "active" : ""}
          aria-current={isSectionActive(["/channel-manager/ari"]) ? "page" : undefined}
          to="/channel-manager/ari/kkkkk"
          title="Rates & Availability"
        >
          <TrendingUp size={16} aria-hidden="true" />
          <span>{t("Rates & Availability")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-item cm-channel-nav-primary">
        <Link
          className={isSectionActive(["/channel-manager/bookings"]) ? "active" : ""}
          aria-current={isSectionActive(["/channel-manager/bookings"]) ? "page" : undefined}
          to="/channel-manager/bookings"
          title="Bookings"
        >
          <Calendar size={16} aria-hidden="true" />
          <span>{t("Bookings")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-divider" aria-hidden="true" />

      <li className="cm-channel-nav-item cm-channel-nav-secondary">
        <Link
          className={isSectionActive(["/channel-manager/property"]) ? "active" : ""}
          aria-current={isSectionActive(["/channel-manager/property"]) ? "page" : undefined}
          to="/channel-manager/property/"
          title="Property"
        >
          <MapPin size={16} aria-hidden="true" />
          <span>{t("Property")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-item cm-channel-nav-secondary">
        <Link
          className={isSectionActive(["/channel-manager/setup"]) ? "active" : ""}
          aria-current={isSectionActive(["/channel-manager/setup"]) ? "page" : undefined}
          to="channel-manager/setup"
          title="Integrations"
        >
          <Grid size={16} aria-hidden="true" />
          <span>{t("Integrations")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-item cm-channel-nav-secondary">
        <Link
          className={isSectionActive(["/channel-manager/ota-settings"]) ? "active" : ""}
          aria-current={isSectionActive(["/channel-manager/ota-settings"]) ? "page" : undefined}
          to="/channel-manager/ota-settings"
          title="Channel Manager Settings"
        >
          <Settings size={16} aria-hidden="true" />
          <span>{t("Settings")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-divider" aria-hidden="true" />

      <li className="cm-channel-nav-item cm-channel-nav-utility">
        <Link
          className={isSectionActive(["/channel-manager/reports"]) ? "active" : ""}
          aria-current={isSectionActive(["/channel-manager/reports"]) ? "page" : undefined}
          to="/channel-manager/reports"
          title="Reports"
        >
          <BarChart2 size={16} aria-hidden="true" />
          <span>{t("Reports")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-item cm-channel-nav-utility">
        <Link
          className={isSectionActive(["/channel-manager/support"]) ? "active" : ""}
          aria-current={isSectionActive(["/channel-manager/support"]) ? "page" : undefined}
          to="/channel-manager/support"
          title="Help & Support"
        >
          <Bell size={16} aria-hidden="true" />
          <span>{t("Support")}</span>
        </Link>
      </li>
    </ul>
  </nav>
</div>
)}
                {isSideMenu === "settings" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li><Link to="/hospitality/property-configuration">{t("Account Settings")}</Link></li>
                        <li><Link to="/privacy-settings">{t("Privacy Settings")}</Link></li>
                        <li><Link to="/notification-settings">{t("Notification Settings")}</Link></li>
                        <li><Link to="/theme-settings">{t("Theme Settings")}</Link></li>
                      </ul>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
      <Chatbot isOpen={isChatbotOpen} toggleChatbot={toggleChatbot} />
    </>
  );
};

export default Sidebar;